import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { UserContext } from '../_models/user-context'
import { ServicesConstants } from '../services-constants'
import { Utente } from '../_models/utente';
import { Utils } from '../utils';

let httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  //  responseType: 'text' as 'text'  // Se si vuole la risposta dal server come solo testo. Cambiare anche la chiamata da post<Tipo> a post
};


@Injectable()
export class AuthenticationService {

  constructor(private http: HttpClient) { }

  login(username: string, password: string) {
    let securityToken = btoa(username + ":" + password);

    let httpOpts = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': 'Basic ' + securityToken
        })      //  responseType: 'text' as 'text'  // Se si vuole la risposta dal server come solo testo. Cambiare anche la chiamata da post<Tipo> a post
    };
  
    // Usata per la chiamata reale
    return this.http.get<UserContext>(ServicesConstants.URL_LOGIN, httpOpts)
      .map(res => {
        if (res) {
          res.securityToken = securityToken;
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          Utils.setUserContext(res);
        }

        return res;
      });
  }

  logout() {
    // remove user from local storage to log user out
    sessionStorage.removeItem('ArubaProvisioningWebFrontEnd:currentUser');
  }

  changePassword(newPassword: string) {
    const url = ServicesConstants.URL_CAMBIOPASSWPRD;

    return this.http.post<any>(url, newPassword, httpOptions);

  }

}



// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts